// WARNING! THOSE NAMES ARE CRITICAL FOR STORAGE. THEY ARE FOLDERS NAMES!

export enum Env
{
    Local = "Local",
    Stage = "Stage",
    Prod = "Prod"
}
